module.exports = __webpack_public_path__ + "img/Hatchback_Side_Left.9e9c89ee.svg";